<ul class="nav nav-tabs" id="comprasTab" role="tablist">
    <li class="nav-item">
        <a class="nav-link active" id="solicitud-tab" data-toggle="tab" href="#solicitud" role="tab"
            aria-controls="solicitud" aria-selected="true">Solicitud de Compra</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" id="orden-tab" data-toggle="tab" href="#orden" role="tab" aria-controls="orden"
            aria-selected="false">Orden de Compra</a>
    </li>
</ul>
<div class="tab-content" id="comprasTabContent">
    <div class="tab-pane fade show active" id="solicitud" role="tabpanel" aria-labelledby="home-tab">
        <app-solicitud-compra></app-solicitud-compra>
    </div>
    <div class="tab-pane fade" id="orden" role="tabpanel" aria-labelledby="profile-tab">
        <app-orden-compra></app-orden-compra>
    </div>
</div>